import {course_getCourseById_Api, courseSchema,} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useContext, useEffect, useMemo, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {CourseContainerContext} from "./CourseContainer";
import {
    PiCertificate,
    PiCertificateFill,
    PiChalkboardTeacher,
    PiClipboardTextFill,
    PiCoinsFill,
    PiCrownSimpleFill,
    PiTextSuperscriptBold,
    PiUsersThreeFill,
    PiWarningCircleFill
} from "react-icons/pi";
import {
    BsArrowLeftCircle,
    BsDisplayFill,
    BsGearFill,
    BsGrid3X3GapFill,
    BsInboxesFill,
    BsPersonFillAdd,
    BsSearch,
    BsTable
} from "react-icons/bs";
import _ from "lodash"
import useTranslate from "../../../../modules/local/useTranslate";
import {getId, getType} from "../../../../apis/model/base";
import {ClassActionTypes, getCourseFeeLabel} from "../../../AppLocals/Course";
import {CourseHeroHeader, EmptyNote, InfoBlock} from "./CourseHeroHeader";
import {useCourseClassForm} from "../../../AppLocals/Course/CourseClass/useCourseClassForm";
import {Button, Input, message} from "antd";
import {FiChevronsRight} from "react-icons/fi";
import {IoCopyOutline} from "react-icons/io5";
import {renderDayOfWeek} from "../../../AppLocals/Church/functions/renderDayOfWeek";
import {TabNavigation} from '../../../Shared/components/TabNavigation'
import {CourseStudentsSearchBinding} from "../../../AppLocals/Course/CourseClass/CourseStudentForm";
import {CourseEnrollmentsByCourseSearchBinding} from "./CourseEnrollmentsByCourse";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {CourseSubjectList} from "../../../AppLocals/Course/CourseSet/CourseSubjectForm";
import {EditCourseModal} from "../../../AppLocals/Course/CourseSet/CourseSetForm";
import {CourseTeachers} from "../../../AppLocals/Course/CourseSet/tabs/CourseTeacherTab";
import {useCourseApi} from "../../../AppLocals/Course/CourseClass/useCourseApi";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import classNames from "classnames";
import {FaUserGraduate} from "react-icons/fa6";
import {ClassroomSvg} from "../../../../components/Svgs/ClassroomSvg";
import {ItemInformation} from 'components/common/ItemInformation'
import {showDeleteConfirmDialog} from "../../../AppLocals/factory/createConfirmDialog";
import {CourseGraduationDashboard} from "./CourseGraduationDashboard";
import {CourseFinanceDashboard} from "./CourseFinanceDashboard";
import {useSelectEntities} from "../../../../redux/entities/useSelectEntities";
import copyToClipboard from "copy-to-clipboard";
import useScrollHide from "../../../../hooks/useScrollHide";
import dayjs from "dayjs";

// --- Cấu trúc Menu Cấp 2 (Chi tiết Khóa học) ---
const COURSE_TABS = [
    {key: 'overview', name: 'overview', icon: <BsDisplayFill size={18}/>},
    {key: 'classes', name: 'classes', icon: <ClassroomSvg size={14}/>},
    {key: 'enrollment', name: 'enrollment', icon: <BsPersonFillAdd size={18}/>},
    // "Tài Chính & Học Phí" đứng NGAY TRƯỚC "Học viên" (bạn yêu cầu) - quản lý định mức phí/tín chỉ
    // + tình trạng đóng học phí từng học viên, xem CourseFinanceDashboard.js.
    {key: 'finance', name: 'tuition fees', icon: <PiCoinsFill size={17}/>},
    {key: 'student', name: 'students', icon: <FaUserGraduate size={15}/>},
    // "Ban điều hành" đứng NGAY SAU "Học viên", NGAY TRƯỚC "Môn học" - bạn yêu cầu, khớp thứ tự
    // đã đổi ở CourseClassDetail.js (2 tab Môn học/Giảng viên liên quan trực tiếp tới nhau nên đặt
    // cạnh nhau) cho đồng bộ giữa trang Khóa và trang Lớp.
    {key: 'teacher', name: 'course committee', icon: <PiCrownSimpleFill size={16}/>},
    {key: 'subject', name: 'subjects', icon: <PiTextSuperscriptBold size={18}/>},
    {key: 'graduation', name: 'assessment', icon: <PiCertificate size={16}/>},
    {key: 'settings', name: 'course settings', icon: <BsGearFill size={16}/>},
];


// Badge trạng thái lớp (Đang học/Chờ khai giảng/Đã kết thúc) - viết RIÊNG cho card lớp học ở đây,
// KHÔNG dùng chung getClassStatusBadge() của CourseClassPage.js vì hàm đó trả null khi lớp đang học
// (ẩn hẳn badge cho case phổ biến nhất - đúng cho header lớp), còn mockup ở màn này LUÔN muốn thấy
// badge cho cả 3 trạng thái. Cần course_classes có from_date/to_date (đã thêm opt-in ở
// CourseTransformer.php::course_classes).
const getClassCardStatus = (cls, t) => {
    const {from_date, to_date} = cls ?? {}
    const now = dayjs()
    if (to_date && dayjs(to_date).isBefore(now)) {
        return {label: t('ended'), className: 'bg-color-100 text-color-400'}
    }
    if (from_date && dayjs(from_date).isAfter(now)) {
        return {label: t('upcoming'), className: 'bg-amber-50 text-amber-600'}
    }
    return {label: t('in progress'), className: 'bg-green-50 text-green-600'}
}

// Hình thức học (Online/Trực tiếp) suy từ location_address của buổi học đầu tiên - Course có
// delivery_mode riêng nhưng đó là CẤP KHÓA (Course::DELIVERY_MODE_*), không phản ánh đúng từng LỚP
// (1 khóa có thể có lớp online lẫn lớp offline khác phòng) - CourseClass/Timetable chưa có field
// "hình thức" riêng, nên suy từ location_address có/không, KHÔNG bịa ra khái niệm "Hybrid" (không có
// dữ liệu nguồn cho case đó).
const getClassModeLabel = (cls, t) => {
    const location = _.get(cls, 'timetables.0.location_address')
    return location ? `${t('offline')} - ${location}` : t('online')
}

// hideBackLink/overviewExtra: cho phép nhúng LẠI ĐÚNG component này ở màn khác đã tự vẽ điều hướng
// riêng - CourseClassOperations.js ("Điều hành Khóa & Lớp học", bạn yêu cầu "dùng lại, không clone"
// thay vì tự dựng 1 bộ header+tab song song). hideBackLink: ẩn nút "Quay lại danh sách Khóa học" (ở
// đó khóa vẫn hiển thị nối tiếp trên cùng 1 màn qua selector riêng, không phải luồng back/forward -
// cùng lý do CourseClassDetail.js đã có hideHeader). overviewExtra: node tuỳ chọn chèn THÊM vào CUỐI
// tab "Tổng quan" (sau khối "Nội dung cần khai báo") - CourseClassOperations.js dùng để nhúng
// CourseSchedulePanel (lịch học của khóa), thứ CourseDetail.js gốc không có vì không phải màn vận
// hành hằng ngày.
const CourseDetail = ({hideBackLink = false, overviewExtra = null}) => {
    const t = useTranslate();
    const courseDetailTab = useRouteSearchParam("course-detail-tab") || "overview"
    const [activeTab, setActiveTab] = useState(courseDetailTab);
    const {isSm, isLg} = useContext(LayoutContext)

    // Tab "Lớp học" - 2 view Thẻ/Bảng (bạn yêu cầu), mặc định 'card' để khớp mockup - cùng convention
    // toggle Thẻ/Bảng đang dùng ở Students.js (viewModeToggle). classSearch lọc CỤC BỘ trên
    // course_classes đã có sẵn trong currentCourse (không gọi API riêng - danh sách lớp 1 khóa thường
    // không nhiều, không cần phân trang).
    const [classViewMode, setClassViewMode] = useState('card')
    const [classSearch, setClassSearch] = useState('')

    const {hidden} = useScrollHide()

    const [selectedCourse, setSelectedCourse] = useState({});
    const {
        current_course_id, setCurrentCourseId,
        current_course_class_id, setCurrentCourseClassId,
        onSelectCourseContainerRoute
    } = useContext(CourseContainerContext);


    const {handleAsyncAction: getCourseById} = useAsyncAction({
        apiInfo: course_getCourseById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            // useAsyncAction bắn onSuccess qua setTimeout và có thể chạy lại vài lần khi
            // isLoading/success đổi. Set thẳng (kể cả set {} khi payload chưa có) làm currentCourse
            // nhấp nháy mất .owner -> CurriculaSelect mount/unmount liên tục, useAsync gọi lại API
            // curriculum không ngừng kèm render loop. Bỏ qua payload rỗng và chỉ set khi khóa thực
            // sự đổi (theo id) để onSuccess idempotent, cắt vòng lặp.
            const nextId = dataItem?.id;
            if (!nextId) return;

            setTimeout(() => {
                setSelectedCourse((prev) => (prev?.id === nextId ? prev : dataItem));
            }, 500)
        },
    })
    const {onChangeSearchParams} = useRouterSearchParam({})

    const {
        modal,
        handleAction,
        onCancel,
        refreshKey
    } = useCourseClassForm({course: selectedCourse})

    const {
        onCourseUpdate, onCourseDelete, isUpdatingCourse,
    } = useCourseApi({owner_id: selectedCourse?.owner?.id, owner_type: getType(selectedCourse?.owner)})


    useEffect(() => {
        if (current_course_id) {
            setTimeout(() => {
                getCourseById({}, {id: current_course_id})
            }, 300)
        }
    }, [current_course_id])

    const currentCourse = useSelectEntities(
        getId(selectedCourse),
        courseSchema,
        selectedCourse
    )

    const courseClasses = _.get(currentCourse, 'course_classes', []);
    // Hoist lên cấp component (trước chỉ khai báo cục bộ trong case 'overview') - hero header giờ
    // cũng cần con số này cho khối 3-số-liệu gọn (xem comment ở hero, bạn yêu cầu đưa lên trên khớp
    // hình mẫu CourseClassOperations.js).
    const teacherCount = _.get(currentCourse, 'course_teachers', []).length

    // Số lượng cạnh tên tab ("Lớp học 7", "Học viên 156" - theo mockup) - dùng countValue mới thêm
    // ở TabNavigation (khác hẳn `count` cũ - chấm đỏ nhỏ tra theo LoginContext). Ban điều hành +
    // Môn học đọc từ mảng course_teachers/subjects có sẵn trên entity khóa (đã dùng ở tab Tổng quan).
    const tabsWithCounts = useMemo(
        () => COURSE_TABS.map((tab) => {
            if (tab.key === 'classes') return {...tab, countValue: courseClasses.length}
            if (tab.key === 'student') return {...tab, countValue: currentCourse?.student_count ?? 0}
            if (tab.key === 'teacher') return {...tab, countValue: _.get(currentCourse, 'course_teachers', []).length}
            if (tab.key === 'subject') return {...tab, countValue: _.get(currentCourse, 'subjects', []).length}
            return tab
        }),
        [courseClasses.length, currentCourse?.student_count, currentCourse?.course_teachers, currentCourse?.subjects]
    )

    // courseStateInfo/weekProgress (badge trạng thái, thanh tiến trình) TRƯỚC ĐÂY tính ở đây riêng
    // cho hero tự vẽ - giờ hero đã chuyển thành CourseHeroHeader dùng chung (xem return() bên dưới),
    // tự tính 2 giá trị này NỘI BỘ từ currentCourse, không cần truyền vào nữa.

    // Render nội dung cụ thể cho từng tab Cấp 2
    const renderCourseContent = useMemo(() => {
            switch (activeTab) {
                case 'overview': {
                    const subjects = _.get(currentCourse, 'subjects', [])

                    return (
                        <div className="flex flex-col gap-4">
                            {/* Alert mạnh riêng cho Môn học - bạn yêu cầu: khác các trường khai báo
                                khác (tuyển sinh/điều kiện/chứng nhận vẫn hợp lý để trống tạm thời),
                                Môn học BẮT BUỘC phải có mới mở lớp/điểm danh/chấm điểm/xét chứng nhận
                                được, nên tách hẳn thành banner đỏ riêng đứng đầu tab, không gộp chung
                                mức độ với EmptyNote hổ phách nhạt của các trường còn lại. Chỉ hiện khi
                                đã tải xong (currentCourse?.id) - tránh nháy banner sai lúc đang load. */}
                            {!!currentCourse?.id && subjects.length === 0 && (
                                <div className="p-4 flex items-start gap-3 bg-red-50 border-2 border-red-200 rounded-2xl">
                                    <PiWarningCircleFill size={22} className="mt-0.5 flex-shrink-0 text-red-500"/>
                                    <div className="flex-1 flex flex-col gap-1 min-w-0">
                                        <span className="font-bold text-sm text-red-700 tracking-wide">
                                            {t('course missing subjects alert title')}
                                        </span>
                                        <span className="text-sm text-red-600 tracking-wide">
                                            {t('course missing subjects alert description')}
                                        </span>
                                    </div>
                                    <button
                                        onClick={() => setActiveTab('subject')}
                                        className="px-4 py-2 flex-shrink-0 bg-red-600 hover:bg-red-700 font-semibold text-sm text-white shadow-md rounded-lg transition">
                                        {t('declare subjects now')}
                                    </button>
                                </div>
                            )}

                            {/* 3 thẻ thống kê nhanh (Số lớp/Học viên/Ban giảng huấn) + card "Thông tin
                                chi tiết Khóa học" TRƯỚC ĐÂY đứng ở đây - bạn góp ý cả 2 lặp thông tin
                                với header navy phía trên (badge trạng thái/năm học, ngày mở-đóng, mã
                                khóa...) nên đã BỎ HẲN, dời 3 con số lên header (dạng gọn, khớp mẫu
                                CourseClassOperations.js) và thêm "Hạn ghi danh cuối" luôn hiện ở đó
                                (trước chỉ hiện khi có giá trị) - xem khối hero phía dưới return(). */}

                            {/* Nội dung cần khai báo - ghép từ CourseClassOperations.js (màn "Điều
                                hành Khóa & Lớp học") sang tab Tổng quan này (bạn yêu cầu gộp), dùng
                                lại NGUYÊN InfoBlock/EmptyNote export từ đó, không viết lại bản song
                                song. */}
                            <div className="flex flex-col gap-3">
                                <div className="flex flex-col gap-0.5">
                                    <h3 className="font-bold text-base text-color-000 tracking-wide">
                                        {t('content to declare title')}
                                    </h3>
                                    <span className="text-xs text-color-300 tracking-wide">
                                        {t('content to declare description')}
                                    </span>
                                </div>
                                <div className="p-4 bg-amber-50 border border-amber-200 rounded-2xl grid grid-cols-1 lg:grid-cols-2 gap-4">
                                    {/* 1. Tuyển sinh & chiêu sinh */}
                                    <InfoBlock icon={<PiClipboardTextFill size={16} className="text-orange-500"/>} title={t('admission and recruitment info')}>
                                        <div className="flex flex-col gap-2">
                                            {currentCourse?.last_enrollment_time ? (
                                                <ItemInformation showIcon label="application deadline" value={formatSimplifyDate(currentCourse.last_enrollment_time, null, 'DD MMMM, YYYY')} className="text-sm"/>
                                            ) : (
                                                <EmptyNote>{t('no application deadline declared')}</EmptyNote>
                                            )}
                                            <ItemInformation
                                                showIcon
                                                label="recruitment quota"
                                                value={currentCourse?.student_quota
                                                    ? `${currentCourse.student_quota} ${t('student').toLowerCase()} (${courseClasses.length} ${t('classes').toLowerCase()})`
                                                    : <EmptyNote>{t('no recruitment quota declared')}</EmptyNote>}
                                                className="text-sm"
                                            />
                                            <ItemInformation showIcon label="opening date" value={formatSimplifyDate(currentCourse?.time_open, null, 'DD MMMM, YYYY')} className="text-sm"/>
                                            <ItemInformation
                                                showIcon
                                                label="fee amount"
                                                value={getCourseFeeLabel(currentCourse, t, {freeLabelKey: 'completely free'})}
                                                className="text-sm"
                                            />
                                            {currentCourse?.coordinator_name ? (
                                                <ItemInformation showIcon label="instructor in charge" value={currentCourse.coordinator_name} className="text-sm"/>
                                            ) : (
                                                <EmptyNote>{t('no instructor in charge declared')}</EmptyNote>
                                            )}
                                        </div>
                                    </InfoBlock>

                                    {/* 2. Danh sách lớp & môn học khung - EmptyNote hổ phách nhạt như mọi
                                        field khác trong khối này ĐÃ ĐỔI thành alert đỏ đậm hơn riêng cho
                                        Môn học (bạn yêu cầu: môn học buộc phải có) - banner đỏ đầu tab đã
                                        cảnh báo tổng quát, đây là chỗ khai báo cụ thể nên nhắc lại ngay
                                        tại chỗ, đậm hơn EmptyNote nhưng gọn hơn banner (không lặp nút CTA
                                        to, chỉ 1 dòng + link). */}
                                    <InfoBlock icon={<PiUsersThreeFill size={16} className="text-indigo-500"/>} title={t('class list and core subjects')}>
                                        <div className="flex flex-col gap-2">
                                            <span className="text-xs font-medium text-color-300 tracking-wide">
                                                {t('classes recruiting or teaching')}
                                            </span>
                                            {courseClasses.length > 0 ? (
                                                <div className="flex flex-wrap gap-2">
                                                    {courseClasses.map((cls) => (
                                                        <button
                                                            key={cls.id}
                                                            onClick={() => onSelectCourseContainerRoute({current_course_class_id: cls.id})}
                                                            className="px-2.5 py-1 flex flex-center gap-1 bg-slate-100 hover:bg-indigo-100 border border-slate-200 hover:border-indigo-300 rounded-full font-medium text-xs text-slate-600 hover:text-indigo-600 tracking-wide cursor-pointer">
                                                            {cls.title}
                                                            {cls.student_count > 0 && <span className="text-color-400">({cls.student_count})</span>}
                                                        </button>
                                                    ))}
                                                </div>
                                            ) : (
                                                <EmptyNote>{t('no classes created yet')}</EmptyNote>
                                            )}
                                            <div className="mt-1 border-t border-color-50"/>
                                            <span className="text-xs font-medium text-color-300 tracking-wide">
                                                {t('mandatory subjects')}
                                            </span>
                                            {subjects.length > 0 ? (
                                                <ul style={{paddingLeft: 18, listStyleType: 'decimal'}} className="flex flex-col gap-0.5">
                                                    {subjects.map((cs) => (
                                                        <li key={cs.id} className="text-sm text-color-100 tracking-wide">
                                                            {_.get(cs, 'subject.title')}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <div className="flex items-center gap-1.5">
                                                    <PiWarningCircleFill size={13} className="flex-shrink-0 text-red-500"/>
                                                    <span className="text-xs font-bold text-red-600 tracking-wide">
                                                        {t('core subjects required warning')}
                                                    </span>
                                                    <button
                                                        onClick={() => setActiveTab('subject')}
                                                        className="text-xs font-semibold text-red-600 hover:text-red-700 underline">
                                                        {t('declare subjects now')}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </InfoBlock>

                                    {/* 3. Điều kiện & quy trình đăng ký */}
                                    <InfoBlock icon={<PiChalkboardTeacher size={16} className="text-emerald-500"/>} title={t('registration conditions and process')}>
                                        <div className="flex flex-col gap-2">
                                            <span className="text-xs font-medium text-color-300 tracking-wide">
                                                {t('eligibility requirements')}
                                            </span>
                                            {currentCourse?.eligibility_requirements ? (
                                                <p className="text-sm text-color-100 tracking-wide whitespace-pre-line">
                                                    {currentCourse.eligibility_requirements}
                                                </p>
                                            ) : (
                                                <EmptyNote>{t('eligibility requirements not declared yet')}</EmptyNote>
                                            )}
                                            <div className="mt-1 border-t border-color-50"/>
                                            <span className="text-xs font-medium text-color-300 tracking-wide">
                                                {t('required documents')}
                                            </span>
                                            {currentCourse?.required_documents ? (
                                                <p className="text-sm text-color-100 tracking-wide whitespace-pre-line">
                                                    {currentCourse.required_documents}
                                                </p>
                                            ) : (
                                                <EmptyNote>{t('required documents not declared yet')}</EmptyNote>
                                            )}
                                        </div>
                                    </InfoBlock>

                                    {/* 4. Bằng cấp & tiêu chuẩn xét tốt nghiệp */}
                                    <InfoBlock icon={<PiCertificateFill size={16} className="text-primary-500"/>} title={t('certificate and graduation criteria')}>
                                        <div className="flex flex-col gap-2">
                                            {currentCourse?.medal?.title ? (
                                                <ItemInformation showIcon label="certificate awarded" value={currentCourse.medal.title} className="text-sm"/>
                                            ) : (
                                                <EmptyNote>{t('no certificate configured')}</EmptyNote>
                                            )}
                                            <div className="mt-1 border-t border-color-50"/>
                                            <span className="text-xs font-medium text-color-300 tracking-wide">
                                                {t('graduation criteria')}
                                            </span>
                                            {currentCourse?.graduation_criteria ? (
                                                <p className="text-sm text-color-100 tracking-wide whitespace-pre-line">
                                                    {currentCourse.graduation_criteria}
                                                </p>
                                            ) : (
                                                <EmptyNote>{t('graduation criteria not declared yet')}</EmptyNote>
                                            )}
                                        </div>
                                    </InfoBlock>
                                </div>
                            </div>

                            {/* overviewExtra - CourseClassOperations.js nhúng CourseSchedulePanel vào
                                đây (xem comment ở khai báo prop, đầu file). null ở mọi nơi khác đang
                                dùng CourseDetail.js qua CourseContainer.js (không truyền prop này). */}
                            {overviewExtra}
                        </div>
                    );
                }
                case 'classes': {
                    // Lọc CỤC BỘ theo tên hoặc mã lớp (course_classes đã có sẵn, không cần API riêng).
                    const filteredClasses = classSearch
                        ? courseClasses.filter((cls) => {
                            const kw = classSearch.trim().toLowerCase()
                            return cls?.title?.toLowerCase().includes(kw)
                                || cls?.course_class_idcode?.toLowerCase().includes(kw)
                        })
                        : courseClasses

                    // 2 ACTION giữ nguyên y hệt bản cũ, dùng chung cho CẢ 2 view (card/bảng) - KHÔNG
                    // thêm/bớt action nào khác theo đúng yêu cầu "giữ các action":
                    //   - "Tạo lớp học mới": handleAction(ClassActionTypes.CLASS_CREATE) - nút trên đầu.
                    //   - "Xem chi tiết": onSelectCourseContainerRoute({current_course_class_id}) - mỗi dòng/thẻ.
                    const viewClassDetail = (id) => onSelectCourseContainerRoute({current_course_class_id: id})

                    return (
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                <div className="flex flex-col">
                                    <h3 className="font-bold text-lg text-color-000 tracking-wide">
                                        {`${t('list of classes')} (${courseClasses.length})`}
                                    </h3>
                                    {currentCourse?.course_idcode && (
                                        <span className="text-xs text-color-300 italic">
                                            {t('manage classes of this course', {code: currentCourse.course_idcode})}
                                        </span>
                                    )}
                                </div>
                                <div className="flex items-center gap-2 flex-shrink-0">
                                    <Input
                                        allowClear
                                        prefix={<BsSearch size={12} className="text-color-300"/>}
                                        placeholder={t('search by class name or code')}
                                        value={classSearch}
                                        onChange={(e) => setClassSearch(e.target.value)}
                                        style={{width: 220}}
                                        className="rounded-lg"
                                    />
                                    {/* Toggle Thẻ/Bảng - cùng convention viewModeToggle của Students.js */}
                                    <div className="flex items-center flex-shrink-0 rounded-lg border border-color-200 overflow-hidden">
                                        <button
                                            type="button"
                                            title={t('card')}
                                            onClick={() => setClassViewMode('card')}
                                            style={{width: 36, height: 36}}
                                            className={classNames(
                                                "flex flex-center transition-colors",
                                                classViewMode === 'card' ? 'bg-indigo-500 text-white' : 'background text-color-300 hover:text-indigo-600'
                                            )}>
                                            <BsGrid3X3GapFill size={13}/>
                                        </button>
                                        <button
                                            type="button"
                                            title={t('table')}
                                            onClick={() => setClassViewMode('table')}
                                            style={{width: 36, height: 36}}
                                            className={classNames(
                                                "flex flex-center transition-colors border-l border-color-200",
                                                classViewMode === 'table' ? 'bg-indigo-500 text-white' : 'background text-color-300 hover:text-indigo-600'
                                            )}>
                                            <BsTable size={13}/>
                                        </button>
                                    </div>
                                    <Button
                                        color="primary" variant="solid"
                                        className="px-3 flex flex-center flex-shrink-0 font-medium rounded-lg shadow-md transition"
                                        onClick={() => {
                                            handleAction(ClassActionTypes.CLASS_CREATE)
                                        }}>
                                        {t('create class')}
                                    </Button>
                                </div>
                            </div>

                            {filteredClasses.length === 0 ? (
                                <div className="p-6 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                                    <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                                    <span className="text-center text-sm text-color-300 tracking-wider italic">
                                        {t(courseClasses.length ? 'no matching classes found' : 'no classes created yet')}
                                    </span>
                                </div>
                            ) : classViewMode === 'card' ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {filteredClasses.map((cls) => {
                                        const status = getClassCardStatus(cls, t)
                                        const modeLabel = getClassModeLabel(cls, t)
                                        const timetable = _.get(cls, 'timetables.0')
                                        return (
                                            <div
                                                key={cls.id}
                                                className="p-4 flex flex-col gap-2.5 background border border-color-50 rounded-2xl hover:shadow-md transition-all duration-300">
                                                <div className="flex items-center justify-between gap-2">
                                                    <span className="px-2 py-0.5 rounded-md text-2xs font-semibold background-100 text-color-400 max-lines-1">
                                                        {modeLabel}
                                                    </span>
                                                    <span className={classNames('px-2 py-0.5 rounded-full text-2xs font-semibold flex-shrink-0', status.className)}>
                                                        {status.label}
                                                    </span>
                                                </div>
                                                <h4
                                                    onClick={() => viewClassDetail(cls.id)}
                                                    className="font-bold text-base text-color-000 hover:text-primary cursor-pointer leading-snug">
                                                    {cls.title}
                                                </h4>
                                                <span
                                                    onClick={() => {
                                                        copyToClipboard(cls?.course_class_idcode)
                                                        message.info(t('copied'))
                                                    }}
                                                    className="w-fit px-2 py-0.5 rounded-full background-100 font-mono text-2xs font-semibold text-blue-600 hover:text-blue-700 cursor-pointer flex items-center gap-1">
                                                    {`${t('class code')}: #${cls?.course_class_idcode}`}
                                                    <IoCopyOutline size={10}/>
                                                </span>
                                                <div className="flex flex-col gap-1.5 p-3 background-50 rounded-xl">
                                                    <ItemInformation
                                                        showIcon={true}
                                                        label="teacher"
                                                        value={_.get(cls, 'coordinators.0.teacher.fullname') || '—'}
                                                        className="text-xs"
                                                    />
                                                    <ItemInformation
                                                        showIcon={true}
                                                        label="student"
                                                        value={`${cls?.student_count ?? 0} ${t('student').toLowerCase()}`}
                                                        className="text-xs"
                                                    />
                                                    {timetable && (
                                                        <ItemInformation
                                                            showIcon={true}
                                                            label="class schedule"
                                                            value={<span>{renderDayOfWeek(timetable.days_of_week)} ({timetable.from_time?.slice(0, 5)} - {timetable.to_time?.slice(0, 5)})</span>}
                                                            className="text-xs"
                                                        />
                                                    )}
                                                </div>
                                                <div className="flex justify-end pt-1 border-t border-color-50">
                                                    <button
                                                        onClick={() => viewClassDetail(cls.id)}
                                                        className="text-xs font-semibold text-indigo-600 hover:text-indigo-700 flex items-center gap-1">
                                                        {t('view detail')} <FiChevronsRight size={12}/>
                                                    </button>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            ) : (
                                <div className="w-full overflow-x-auto rounded-xl border border-color-50">
                                    <table className="w-full" style={{borderCollapse: 'collapse'}}>
                                        <thead>
                                        <tr className="background-50 text-left">
                                            <th className="px-3 py-2.5 text-2xs font-bold text-color-400 uppercase tracking-wider">{t('list of classes')}</th>
                                            <th className="px-3 py-2.5 text-2xs font-bold text-color-400 uppercase tracking-wider">{t('teacher')}</th>
                                            <th className="px-3 py-2.5 text-2xs font-bold text-color-400 uppercase tracking-wider">{t('student')}</th>
                                            <th className="px-3 py-2.5 text-2xs font-bold text-color-400 uppercase tracking-wider">{t('class schedule')}</th>
                                            <th className="px-3 py-2.5 text-2xs font-bold text-color-400 uppercase tracking-wider">{t('status')}</th>
                                            <th className="px-3 py-2.5 text-right text-2xs font-bold text-color-400 uppercase tracking-wider">{t('actions')}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {filteredClasses.map((cls) => {
                                            const status = getClassCardStatus(cls, t)
                                            const timetable = _.get(cls, 'timetables.0')
                                            return (
                                                <tr key={cls.id} className="border-t border-color-50 background hover:background-50 transition-colors">
                                                    <td className="px-3 py-2.5">
                                                        <div className="flex flex-col">
                                                            <span
                                                                onClick={() => viewClassDetail(cls.id)}
                                                                className="font-semibold text-sm text-color-000 hover:text-primary cursor-pointer leading-snug">
                                                                {cls.title}
                                                            </span>
                                                            <span className="font-mono text-2xs text-blue-500">#{cls?.course_class_idcode}</span>
                                                        </div>
                                                    </td>
                                                    <td className="px-3 py-2.5 text-sm text-color-200">
                                                        {_.get(cls, 'coordinators.0.teacher.fullname') || '—'}
                                                    </td>
                                                    <td className="px-3 py-2.5 text-sm text-color-200">
                                                        {cls?.student_count ?? 0}
                                                    </td>
                                                    <td className="px-3 py-2.5 text-sm text-color-200">
                                                        {timetable ? <span>{renderDayOfWeek(timetable.days_of_week)} ({timetable.from_time?.slice(0, 5)} - {timetable.to_time?.slice(0, 5)})</span> : '—'}
                                                    </td>
                                                    <td className="px-3 py-2.5">
                                                        <span className={classNames('px-2 py-0.5 rounded-full text-2xs font-semibold', status.className)}>
                                                            {status.label}
                                                        </span>
                                                    </td>
                                                    <td className="px-3 py-2.5 text-right">
                                                        <button
                                                            type="button"
                                                            onClick={() => viewClassDetail(cls.id)}
                                                            style={{width: 28, height: 28}}
                                                            className="inline-flex flex-center rounded-full border border-color-200 hover:border-primary hover:background-100 text-color-400 hover:text-primary">
                                                            <FiChevronsRight size={13}/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    );
                }
                case 'enrollment':
                    return (
                        <div className="flex flex-col">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("manage enrollment applications")}
                            </h3>
                            {!!currentCourse?.id && (
                                <CourseEnrollmentsByCourseSearchBinding
                                    owner_id={getId(currentCourse?.owner)}
                                    owner_type={getType(currentCourse?.owner)}
                                    course_id={currentCourse?.id}
                                    subjects={_.get(currentCourse, 'subjects', [])}
                                    metadata={_.get(currentCourse, 'metadata', [])}
                                    showHeader={false}
                                />
                            )}
                            <div className="mt-6 p-3 background-100 rounded-lg text-sm">
                                <span className="font-bold text-color-000">
                                    {`${t('note')}: `}
                                </span>
                                <span className="text-color-200 italic tracking-wider">
                                    {t("a student can belong to multiple classes within this course")}
                                </span>
                            </div>
                        </div>
                    );
                case 'finance':
                    if (!!!currentCourse?.id) return null;
                    return (
                        <CourseFinanceDashboard
                            course_id={currentCourse.id}
                            can_edit={!!currentCourse.edit}
                            fee_mode={currentCourse.fee_mode}
                            fee_amount={currentCourse.fee_amount}
                            fee_currency_code={currentCourse.fee_currency_code}
                            fee_structure_type={currentCourse.fee_structure_type}
                        />
                    );
                case 'student':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {`${t("student management")} (${currentCourse.student_count ?? 0})`}
                            </h3>

                            {!!currentCourse?.id && (
                                <CourseStudentsSearchBinding
                                    owner_id={getId(currentCourse?.owner)}
                                    owner_type={getType(currentCourse?.owner)}
                                    item={currentCourse}
                                    showHeader={false}
                                />
                            )}
                            <div className="mt-6 p-3 background-100 rounded-lg text-sm">
                            <span className="font-bold text-color-000">
                                {`${t('note')}: `}
                            </span>
                                <span className="text-color-200 italic tracking-wider">
                                {t("a student can belong to multiple classes within this course")}
                            </span>
                            </div>
                        </div>
                    );
                case 'subject':
                    return (
                        <div className="flex flex-col gap-3">
                            {!!currentCourse?.id && bindingSearch({
                                onCancel,
                                owner_id: getId(currentCourse?.owner),
                                owner_type: getType(currentCourse?.owner),
                                item: currentCourse,
                            })(CourseSubjectList)}
                        </div>
                    );
                case 'teacher':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("course committee")}
                            </h3>
                            {!!currentCourse?.id && (
                                <CourseTeachers item={currentCourse}/>
                            )}
                        </div>
                    );
                case 'graduation':
                    if (!!!currentCourse?.id) return null;
                    return (
                        <CourseGraduationDashboard
                            course_id={currentCourse.id}
                            course={currentCourse}
                            can_edit={!!currentCourse.edit}
                        />
                    );
                case 'settings':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("course settings")}
                            </h3>
                            <div className="p-3 background border border-color-50 shadow-md rounded-lg">
                                <ul style={{paddingLeft: 20, listStyleType: 'disc'}} className="flex flex-col gap-1">
                                    <li className="text-color-300 tracking-wider">
                                        {t("manage name description and official start end dates")}
                                    </li>
                                    <li className="text-color-300 tracking-wider">
                                        {t("configure certificate template awarded upon course completion")}
                                    </li>
                                </ul>
                            </div>

                            <div className="mt-3">
                                {
                                    !!currentCourse?.id && (
                                        <EditCourseModal
                                            initialValues={currentCourse}
                                            owner_id={getId(currentCourse?.owner)}
                                            owner_type={getType(currentCourse?.owner)}
                                            onCancel={onCancel}
                                            isSubmitting={isUpdatingCourse}
                                            onSubmit={(values) => {
                                                onCourseUpdate(values, {id: currentCourse?.id})
                                            }}
                                        />
                                    )
                                }
                            </div>

                            {/* "Xóa khóa học" - TRƯỚC ĐÂY là 1 tab riêng ("Xóa nội dung", key='destroy') -
                                gộp xuống cuối tab "Cấu hình Khóa học" để gọn menu, bỏ hẳn tab riêng
                                (cùng cách đã làm cho CourseClassDetail.js). Giữ NGUYÊN hành động
                                (showDeleteConfirmDialog -> onCourseDelete), chỉ đổi vị trí + đóng
                                khung riêng viền/nền đỏ (KHÔNG chỉ viền trái mỏng như trước) để tách
                                bạch khỏi phần cấu hình thường phía trên - CHỈ dùng màu đỏ làm tín hiệu
                                cảnh giác (không thêm tag/badge "Vùng nguy hiểm" - bạn đã chốt bỏ ở
                                CourseClassDetail.js, áp dụng nhất quán ở đây luôn). Đổi nút từ
                                bg-primary-600 (xanh, không hợp ngữ cảnh xóa) sang bg-red-600 cho đúng
                                tinh thần cảnh báo.
                            */}
                            <div className="mt-8 p-4 rounded-xl border-2 border-red-200 bg-red-50 flex flex-col">
                                <div className="mb-3 flex flex-col flex-1">
                                    <h3 className="font-bold text-base text-red-700 tracking-wide">
                                        {t("delete course")}
                                    </h3>
                                    <div className="text-red-500 tracking-wider">
                                        {t("this action will permanently delete the course and all related data")}
                                    </div>
                                </div>
                                <div className="flex justify-end">
                                    <button
                                        onClick={() => {
                                            showDeleteConfirmDialog({
                                                translate: t,
                                                title: 'delete this',
                                                message: 'are you sure you want to delete this',
                                                onOk: () => {
                                                    onCourseDelete({}, {id: currentCourse?.id})
                                                },
                                            })
                                        }}
                                        className="px-6 py-2 bg-red-600 hover:bg-red-700 font-medium text-sm text-white shadow-md rounded-lg">
                                        {t("delete course permanently")}
                                    </button>
                                </div>
                            </div>

                        </div>
                    );
                default:
                    return null;
            }
        },
        // classViewMode/classSearch THIẾU ở đây trước đó - bấm đổi Thẻ/Bảng hoặc gõ ô tìm kiếm ở tab
        // 'classes' đổi state thật nhưng useMemo không tính lại (vẫn trả JSX cũ) vì 2 state này không
        // nằm trong dependency, đúng bug "bấm không ăn" bạn báo.
        [activeTab, refreshKey, current_course_id, currentCourse?.id, classViewMode, classSearch, overviewExtra]);

    if (!!!current_course_id) return null

    return (
        <div className="w-full min-h-screen education-theme">
            {/* Header Khóa học - theo mockup: hero nền tối gradient (cùng tông ClassroomHeader,
                CourseClassPage.js), badge trạng thái/năm học bên trái, khung ngày bắt đầu-kết thúc
                bên phải, tên khóa lớn, mã khóa + hạn đăng ký bên dưới. */}
            {!hideBackLink && (
                <button
                    onClick={() => {
                        onSelectCourseContainerRoute({current_course_id: '', current_course_class_id: ''})
                    }}
                    className="mb-2 flex items-center text-xs text-color-400 hover:text-color-200 tracking-wide cursor-pointer">
                    <BsArrowLeftCircle size={14} className="mr-1.5"/>
                    {t("back to course list")}
                </button>
            )}
            {/* Header dùng CHUNG component CourseHeroHeader với khối "Quản trị Khóa học" của
                CourseClassOperations.js (bạn yêu cầu gộp 2 thiết kế gần giống nhau qua 1 component,
                khác nhau qua prop - xem CourseHeroHeader.js). Ở đây: không eyebrow/actions/collapsible
                (trang tự đứng riêng, không cần thu gọn), stats = Lớp/Học viên/Giảng viên (khác 3 số
                liệu Lớp/Học viên/Thời lượng của CourseClassOperations.js). */}
            <CourseHeroHeader
                currentCourse={currentCourse}
                stats={[
                    {value: courseClasses.length, label: t('classes')},
                    {value: currentCourse?.student_count ?? 0, label: t('students')},
                    {value: teacherCount, label: t('teaching staff')},
                ]}
            />

            {/* Navigation Tabs Cấp 2 */}
            <TabNavigation
                tabs={tabsWithCounts}
                activeTab={activeTab}
                style={{
                    marginLeft: !isLg && '-0.75rem',
                    marginRight: !isLg && '-0.75rem',
                }}
                className={classNames("border-color-300 transition-all duration-300 ", isLg ? 'stickyTop1' : hidden ? 'stickyTop' : 'stickyTop1')}
                onTabChange={(value) => {
                    onChangeSearchParams({"course-detail-tab": value})
                    setActiveTab(value)
                }}/>

            {/* Nội dung Tab */}
            <div className="p-3 md:p-6 background rounded-b-2xl shadow-lg">
                {renderCourseContent}
            </div>
            {modal}
            <div className="h-16"/>
        </div>
    );
};


export default CourseDetail
